import React, { useEffect, useState } from "react";
import {getItinerary, getRoutes, IItinerary} from "./Itinerary.service";
import './Itinerary.style.scss'
import * as XLSX from 'xlsx';
import CustomSelect from "../../components/atoms/SelectInput/SelectInput";

const Itinerary = () => {
    const [itinerary, setItinerary] = useState<IItinerary>({name: '', stroke: []});
    const [routes, setRoutes] = useState([]);

    useEffect(() => {
        getRoutes(setRoutes);
    }, []);

    const ExcelIcon = () => (
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path>
            <polyline points="14 2 14 8 20 8"></polyline>
            <line x1="16" y1="13" x2="8" y2="13"></line>
            <line x1="16" y1="17" x2="8" y2="17"></line>
            <polyline points="10 9 9 9 8 9"></polyline>
        </svg>
    );

    const downloadExcel = () => {
        const worksheet = XLSX.utils.json_to_sheet(itinerary.stroke);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Itinerario");

        // Add header row
        XLSX.utils.sheet_add_aoa(worksheet, [["Nombre", "Horario 1", "Horario 2", "Horario 3", "Comentarios"]], { origin: "A1" });

        // Auto-size columns
        const max_width = itinerary.stroke.reduce((w, r) => Math.max(w, r.name.length), 10);
        worksheet["!cols"] = [ { wch: max_width }, { wch: 10 }, { wch: 10 }, { wch: 10 }, { wch: 20 } ];

        // Generate Excel file
        XLSX.writeFile(workbook, `ITINERARIO_${itinerary.name}.xlsx`);
    };

    const handleRouteSelect = (route: { NOMBRE: string; ONLY_NAME: string, TIPO: string }) => {
        getItinerary(setItinerary, route.ONLY_NAME, route.TIPO );
    };

    return (
        <div className="itinerary-container">
            <div className="select-new-routes">
                <CustomSelect
                    label="Ruta"
                    options={routes}
                    onSelect={handleRouteSelect}
                />
            </div>
            {itinerary.stroke.length > 0 ?
                <><h2>Lista de paradas</h2>
                    <div className="name-button">
                        <h4>RUTA: {itinerary.name}</h4>
                        <button className="excel" onClick={downloadExcel}>
                            <ExcelIcon/> Descargar Excel
                        </button>
                    </div>
                    <table className="itinerary-table">
                        <thead>
                        <tr>
                            <th>Nombre</th>
                            <th>Horario 1</th>
                            <th>Horario 2</th>
                            <th>Horario 3</th>
                            <th>Referencia</th>
                        </tr>
                        </thead>
                        <tbody>
                        {itinerary.stroke.map((item, index) => (
                            <tr key={index}>
                                <td>{item.name}</td>
                                <td>{item.time1}</td>
                                <td>{item.time2}</td>
                                <td>{item.time3}</td>
                                <td>{item.comments}</td>
                            </tr>
                        ))}
                        </tbody>
                    </table>
                    <div className="itinerary-cards">
                        {itinerary.stroke.map((item, index) => (
                            <div key={index} className="itinerary-item">
                                <div className="itinerary-row">
                                    <span className="label">Nombre:</span>
                                    <span className="value">{item.name}</span>
                                </div>
                                <div className="itinerary-row">
                                    <span className="label">Horario 1:</span>
                                    <span className="value">{item.time1}</span>
                                </div>
                                <div className="itinerary-row">
                                    <span className="label">Horario 2:</span>
                                    <span className="value">{item.time2}</span>
                                </div>
                                <div className="itinerary-row">
                                    <span className="label">Horario 3:</span>
                                    <span className="value">{item.time3}</span>
                                </div>
                            </div>
                        ))}
                    </div>
                </> : <strong><span>Selecciona una ruta para poder ver el listado de paradas</span></strong>
            }

        </div>
    );
}

export default Itinerary;
